import { PrinterEyeIcon } from './PrinterEyeIcon';

/**
 * author: Michael Irigoyen
 * id 22BB79BD-B17E-4002-923E-5B6766B967DC
 * name printer-eye
 * version: 5.2.45
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/printer-eye.svg
 * tags
 * - Printer 
 */
export const PrinterPreviewIcon = PrinterEyeIcon;
export default PrinterPreviewIcon